import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../hooks'
import { FormikField } from '../../../../Formik'
import { InputField } from '../../../../Input'
import {
  FLAT_FORM_ENTRANCE_FIELD_MAX_LENGTH,
  FLAT_FORM_FIELD_NAME_ENTRANCE,
} from '../../FlatForm.constants'

function EntranceField() {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  return (
    <FormikField
      hasCounter
      Component={InputField}
      borderless={!isMobileScreenSize}
      fieldComponentProps={{
        label: `${t('Flat.EntranceLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      inline={isMobileScreenSize}
      maxLength={FLAT_FORM_ENTRANCE_FIELD_MAX_LENGTH}
      name={FLAT_FORM_FIELD_NAME_ENTRANCE}
      placeholder={t('Flat.EntrancePlaceholderKey')}
    />
  )
}

export default EntranceField
